// Phase 9 R2 — Manual quantity adjustment (signed delta + required notes).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useAdjustInventoryQuantity() {
  const { activeShop } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      delta,
      notes,
    }: {
      id: string;
      delta: number;
      notes: string;
    }) => {
      const { data, error } = await supabase.rpc('adjust_inventory_quantity', {
        p_id: id,
        p_delta: delta,
        p_notes: notes,
      });
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['inventory-items', activeShop?.id] });
      qc.invalidateQueries({ queryKey: ['inventory-transactions', activeShop?.id, vars.id] });
      toast.success('Quantity adjusted');
    },
    onError: (e: any) => toast.error(e?.message ?? 'Adjustment failed'),
  });
}
